module.exports = __webpack_public_path__ + "img/s1-img5.cf34d13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/s1-img5.png
// module id = 405
// module chunks = 0